/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FeatureFlagRequest extends models.FeatureFlagRequestBase {
    constructor() {
        super();
        this.setDiscriminator("FeatureFlagRequest");
    }

    getFixupPrototypeFunction() { return FeatureFlagRequest.fixupPrototype; }

    static newInstance(model: Partial<FeatureFlagRequest>): FeatureFlagRequest {
        let obj = Object.assign(new FeatureFlagRequest(), model);
        FeatureFlagRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FeatureFlagRequest>): FeatureFlagRequest {
        if (!model) return null;
        return FeatureFlagRequest.newInstance(<FeatureFlagRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FeatureFlagRequest) {
        if (!obj) return;

        models.FeatureFlagRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FeatureFlagRequest): boolean {
        if (models.FeatureFlagRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FeatureFlagRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * The logical category of existing services
     */
    feature_category: models.FeatureCategory;

}
